export const LoginAndLogoutActionTypes={

}


export const DataActionTypes={
    set_DashboardData:"SET_DASHBOARD_DATA",
    set_ProductsData:"SET_PRODUCTS_DATA",
    set_AccountsData:"SET_ACCOUNTS_DATA",
    set_Password_Visibility:"SET_PASSWORD_VISIBILITY"
}


export const productsPageActionTypes={
    set_Selected_Products:"SET_SELECTED_PRODUCTS",
    delete_Selected_Products:"DELETE_SELECTED_PRODUCTS",
    delete_Product_category:"DELETE_PRODUCT_CATEGORY",
    on_Add_Product:"ON_ADD_PRODUCT",
    Add_Product:"ADD_PRODUCT",
    on_Show_Product:"ON_SHOW_PRODUCT",
    show_Add_Category:"SHOW_ADD_CATEGORY",
    on_Add_Category:"ON_ADD_CATEGORY"
}

export const accountsPageActionTypes={
    set_account_on_select:"SET_ACCOUNT_ON_SELECT",
    set_Profile_Picture:"SET_PROFILE_PICTURE",
    set_selected_account:"SET_SELECTED_ACCOUNT",
}